"use client"

import { useEffect } from "react"

/**
 * Starts PostHog after window load + idle time. Only this component sits in the layouts' bundle: the
 * helper module (and through it posthog-js) is imported dynamically once the page is idle. Renders nothing.
 */
export default function PostHogLoader() {
    useEffect(() => {
        const landingHref = window.location.href
        const start = () => {
            import("@/lib/analytics/posthog-client").then((m) => m.startPosthog(landingHref)).catch(() => {})
        }
        const whenIdle = () => {
            if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(start, { timeout: 2000 })
            else setTimeout(start, 2000)
        }
        if (document.readyState === "complete") whenIdle()
        else window.addEventListener("load", whenIdle, { once: true })
    }, [])
    return null
}
